import { render } from "./VoucherCard.vue?vue&type=template&id=c89dec90"
import script from "./VoucherCard.vue?vue&type=script&lang=js"
export * from "./VoucherCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__